/** `accept` entries are extensions (".xlsx") or MIME types; a file matches either. */
export const fileMatchesAccept = (file: File, accept: string[]): boolean => {
  if (accept.length === 0) return true;
  const name = file.name.toLowerCase();
  return accept.some((entry) => {
    const a = entry.trim().toLowerCase();
    if (a.startsWith(".")) return name.endsWith(a);
    if (a.endsWith("/*")) return file.type.startsWith(a.slice(0, -1));
    return file.type === a;
  });
};
